module.exports = __webpack_public_path__ + "img/TerrainReportIcon.efb0bc51.png";